// extracted by mini-css-extract-plugin
export default {"form":"ProjectForm_form__dNX7W","align":"ProjectForm_align__hcG4+"};